// Temporary context solution for the CartMini. To be removed once design tokens are implemented.

import { createContext, type ReactNode, useMemo } from "react";

import { useDetectTheme } from "@jti/ui";

export type CartMiniContextProps = {
  isDarkTheme: boolean;
};

export const CartMiniContext = createContext<CartMiniContextProps | undefined>(undefined);

export const ThemeVariantProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isDarkTheme } = useDetectTheme();

  const contextValue: CartMiniContextProps = useMemo(
    () => ({
      isDarkTheme,
    }),
    [isDarkTheme]
  );

  return <CartMiniContext.Provider value={contextValue}>{children}</CartMiniContext.Provider>;
};
